import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const TournamentRulesPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navigation />

      <main className="flex-grow">
        <div className="bg-black text-white py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl font-bold mb-4">Tournament Rules</h1>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="bg-white rounded-lg shadow-lg p-8">
            <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Format & Play</h2>
              <ul className="space-y-2 text-gray-700">
                <li>• <strong>Format:</strong> Four-player team scramble</li>
                <li>• <strong>Start:</strong> Shotgun start</li>
                <li>• <strong>Teams:</strong> Maximum 4 players per team</li>
                <li>• <strong>Handicaps:</strong> Teams may use handicaps where applicable</li>
                <li>• <strong>Pace of Play:</strong> Groups must maintain appropriate pace of play</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Scramble Rules</h2>
              <ul className="space-y-2 text-gray-700">
                <li>• All team members tee off on each hole</li>
                <li>• Team selects the best drive</li>
                <li>• All players play their next shot from the location of the best ball</li>
                <li>• Continue this format until the ball is holed</li>
                <li>• Each team member must contribute a minimum of 3 drives during the round</li>
                <li>• Mark drives used on the scorecard</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Conduct</h2>
              <ul className="space-y-2 text-gray-700">
                <li>• Proper golf attire required (collared shirts, golf shoes)</li>
                <li>• No denim, tank tops, or athletic shorts</li>
                <li>• Alcoholic beverages provided by the tournament only</li>
                <li>• Golf carts must stay on cart paths where designated</li>
                <li>• Respect the course and repair divots/ball marks</li>
                <li>• Cell phones on silent during play</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Scoring & Awards</h2>
              <ul className="space-y-2 text-gray-700">
                <li>• Teams responsible for keeping accurate scorecards</li>
                <li>• Scorecards must be signed by team captain and verified</li>
                <li>• Awards ceremony following dinner</li>
                <li>• Prizes for: 1st, 2nd, 3rd place teams</li>
                <li>• Special awards: Closest to Pin, Longest Drive</li>
                <li>• Hole-in-one prizes where applicable</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Weather Policy</h2>
              <ul className="space-y-2 text-gray-700">
                <li>• Tournament proceeds rain or shine</li>
                <li>• In case of dangerous weather, play may be suspended</li>
                <li>• Lightning policy: All players must seek shelter immediately</li>
                <li>• Make-up play decisions at tournament director's discretion</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Registration</h2>
              <ul className="space-y-2 text-gray-700">
                <li>• Registration check-in begins 1 hour before shotgun start</li>
                <li>• All team members must check in</li>
                <li>• Photo ID required for all participants</li>
                <li>• Team rosters may be modified up to day of event</li>
                <li>• No-shows: No refunds for absent team members</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">General</h2>
              <ul className="space-y-2 text-gray-700">
                <li>• Tournament director's decisions are final</li>
                <li>• All local rules of the golf course apply</li>
                <li>• USGA rules apply where not otherwise specified</li>
                <li>• Participants play at their own risk</li>
                <li>• Photography/videography may occur during the event</li>
                <li>• By participating, you consent to use of your likeness for promotional purposes</li>
              </ul>
            </section>
          </div>
        </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default TournamentRulesPage;